import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: ${em(300)};
  min-height: ${em(300)};
  padding-top: ${em(30)};
  text-align: center;
  margin: 0 auto;
`
